import React, { ReactNode } from 'react';
import cn from 'classnames';

interface Props {
  id?: string;
  placeholder?: string;
  type?: string;
  name?: string;
  value?: string;
  className?: string;
  inputRef?: any;
  children?: ReactNode;
  onChange?: (e: any) => void;
}

const Input = ({ className, inputRef, type, children, ...props }: Props) => {
  const classes = cn(
    className,
    'border-b-2 border-abn-red bg-abn-gray-light px-2'
  );

  if (type === 'textarea') {
    return <textarea ref={inputRef} className={classes} {...props} />;
  }

  if (type === 'select') {
    return (
      <select ref={inputRef} className={classes} {...props}>
        {children}
      </select>
    );
  }

  return <input type={type} ref={inputRef} className={classes} {...props} />;
};

export default Input;
